import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, Typography, Grid, Divider, CircularProgress } from "@material-ui/core";
import API from "../../actions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Clock from "../Frequents/TimePicker.js";
import DayPicker from "./DayPicker.js";
import moment from "moment";
import update from "immutability-helper";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        padding: "10px 24px 10px 24px"
    },
    daynames: {
        display: "flex",
        marginBottom: "20px",
        marginTop: "10px"
    },
    daycircle: {
        flex: 1,
        height: 50,
        maxWidth: 50,
        marginRight: "auto",
        marginLeft: "auto",
        borderRadius: 25,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    title: {
        textTransform: "uppercase",
        color: "#5f6368",
        fontSize: "14px",
        fontFamily: "Roboto",
        margin: "20px 0 20px 0"
    },
    prescreen: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 100
    },
    repeatWeek: {
        minWidth: 100,
        border: "none",
        backgroundColor: "#F0F0F0",
        borderRadius: "10px",
        marginRight: "10px",
        paddingLeft: "5px",
        outline: "none"
    },
    startDate: {},
    text: {
        marginRight: "10px"
    }
}));

const dayNames = ["M", "T", "O", "T", "F", "L", "S"];

export default props => {
    const classes = useStyles();
    // Declaring all of initial states.
    const [weekDay, setWeekDay] = React.useState("");
    const [frequency, setFrequency] = React.useState(1);
    const [date, setDate] = React.useState(new Date());
    const [repeatNumber, setRepeatNumber] = React.useState(1);
    const [loading, setLoading] = React.useState(false);

    // Declaring other states.
    const [interval, setInterval] = React.useState([]);
    const therapist = useSelector(state => state.data.therapist);

    // StartSetting changeValue functions
    const handleDayNameClick = i => {
        setWeekDay(i);
    };
    const changeFrequency = i => {
        setFrequency(i);
    };
    const changeDate = i => {
        setDate(i);
    };
    const changeRepeatNumber = i => {
        setRepeatNumber(i);
    };
    //

    // Other functions
    const ymdDate = d => {
        var dd = (new Date(Number(d)).getDate() < 10 ? "0" : "") + new Date(Number(d)).getDate();
        var mm = (new Date(Number(d)).getMonth() + 1 < 10 ? "0" : "") + (new Date(Number(d)).getMonth() + 1);
        var yyyy = new Date(Number(d)).getFullYear();
        return yyyy + "-" + mm + "-" + dd;
    };

    const handleSave = async () => {
        // Vodoo Magic
        // Find first relevant date.
        setLoading(true); // Start loading

        try {
            let deltaD = moment(ymdDate(date));
            deltaD = (deltaD.day() - 1) % 6;
            let start = 0;
            let startDate = "";
            if (weekDay >= deltaD) {
                start = moment(date).add(weekDay - deltaD, "days")._d;
                startDate = ymdDate(start);
            } else {
                start = moment(date).add(7 + weekDay - deltaD, "days")._d;
                startDate = ymdDate(start);
            }

            const ll = await API.getOpeningHoursFromTherapist(
                Date.parse(new Date(startDate)),
                Date.parse(new Date(startDate)) + 700 * 24 * 60 * 60 * 1000
            );

            let temp = [];
            for (let i = 0; i < repeatNumber * frequency; i += parseInt(frequency)) {
                const d = moment(startDate).add(i, "weeks")._d;

                for (let j = 0; j < ll.length; j++) {
                    if (ymdDate(Number(ll[j].from)) === ymdDate(Number(d))) {
                        await API.deleteOpeningHours(ll[j].id);
                    }
                }

                interval.forEach(inte => {
                    if (inte.start === inte.end) return;
                    /*temp.push({
                    from: Date.parse(new Date(ymdDate(d) + "T" + inte.start)),
                    to: Date.parse(new Date(ymdDate(d) + "T" + inte.end))
                });*/
                    temp.push({
                        from: moment(ymdDate(d) + "T" + inte.start).valueOf(),
                        to: moment(ymdDate(d) + "T" + inte.end).valueOf()
                    });
                });
            }
            temp.forEach(t => API.addOpeningHours(t.from, t.to));
            props.handleClose();
        } catch (error) {
            console.error("Failed to save:", error);
            // Optionally display error to user
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={() => {
                props.handleClose();
                setWeekDay("");
            }}
            maxWidth="lg"
            fullWidth={true}>
            <div className={classes.root}>
                <Typography variant="h6" gutterBottom>
                    Tilføj åbningstid
                </Typography>
                <Divider />
                <p className={classes.title}>Ugedag</p>
                <div className={classes.daynames}>
                    {dayNames.map((letter, index) => {
                        return (
                            <span
                                key={letter + index}
                                className={classes.daycircle}
                                style={{
                                    backgroundColor:
                                        weekDay === index
                                            ? (JSON.parse(therapist.colors) || ["#4d5ccc", "#4d5ccc"])[1]
                                            : "#F0F0F0",
                                    color: weekDay === index ? "#fff" : "#000"
                                }}
                                onClick={() => handleDayNameClick(index)}>
                                {" " + letter + " "}
                            </span>
                        );
                    })}
                </div>
                <Divider />
                {weekDay !== "" ? (
                    <div style={{ minHeight: 400 }}>
                        <div className={classes.title}>Gentager sig</div>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <select
                                id="repeat-number"
                                className={classes.repeatWeek}
                                onChange={async event => {
                                    await changeFrequency(event.target.value);
                                }}>
                                <option value={1}>Hver uge</option>
                                <option value={2}>Hver 2. uge</option>
                                <option value={3}>Hver 3. uge</option>
                                <option value={4}>Hver 4. uge</option>
                            </select>
                            <p className={classes.text}> starter fra </p>
                            <div className={classes.startDate}>
                                <DayPicker changeValue={changeDate} />
                            </div>
                            <p className={classes.text}> forekommer i alt </p>
                            <input
                                type="number"
                                className={classes.repeatWeek}
                                value={repeatNumber}
                                onChange={async event => {
                                    await changeRepeatNumber(Number(event.target.value));
                                }}
                            />
                            <p className={classes.text}>
                                gang{repeatNumber === 1 ? "" : "e"} og slutter{" "}
                                {moment(date)
                                    .add((repeatNumber - 1) * frequency, "weeks")
                                    .format("LL")}
                            </p>
                        </div>
                        <Divider />
                        <div className={classes.title}>Vælg åbnings intervaller</div>
                        <div>
                            {interval.map((felter, index) => {
                                return (
                                    <div>
                                        <Grid
                                            container
                                            spacing={0}
                                            style={{
                                                backgroundColor: "rgba(220,220,220,0.5)",
                                                padding: "5px 10px 10px 10px",
                                                borderRadius: "5px",
                                                marginBottom: "10px"
                                            }}>
                                            <Grid item sm={4} style={{ width: "100%" }}>
                                                <Clock
                                                    style={{ flex: 1 }}
                                                    value={felter.start}
                                                    // changeValue={value => {
                                                    //     if (felter.end && value > felter.end)
                                                    //         alert("Starttidspunkt skal være før sluttidspunkt!");
                                                    //     else
                                                    //         setInterval(
                                                    //             update(interval, {
                                                    //                 [index]: { start: { $set: value } }
                                                    //             })
                                                    //         );
                                                    // }}

                                                    // changeValue={value => {
                                                    //     const selectedTime = moment(value, "HH:mm:ss");
                                                    //     const rowEndTime = moment(felter.end, "HH:mm:ss");

                                                    //     // Validation 1: Start must be before End (same row)
                                                    //     if (felter.end && selectedTime.isSameOrAfter(rowEndTime)) {
                                                    //         alert("Starttidspunkt skal være før sluttidspunkt!");
                                                    //         return;
                                                    //     }

                                                    //     // Validation 2: Prevent overlap with other rows
                                                    //     const isOverlapping = interval.some((item, i) => {
                                                    //         if (i === index || !item.start || !item.end) return false;
                                                    //         const otherStart = moment(item.start, "HH:mm:ss");
                                                    //         const otherEnd = moment(item.end, "HH:mm:ss");
                                                    //         return selectedTime.isBetween(
                                                    //             otherStart,
                                                    //             otherEnd,
                                                    //             null,
                                                    //             "[)"
                                                    //         );
                                                    //     });

                                                    //     if (isOverlapping) {
                                                    //         alert("Denne tid overlapper med en anden række!");
                                                    //         return;
                                                    //     }

                                                    //     // Passes all validations
                                                    //     setInterval(
                                                    //         update(interval, {
                                                    //             [index]: { start: { $set: value } }
                                                    //         })
                                                    //     );
                                                    // }}

                                                    changeValue={value => {
                                                        const selectedTime = moment(value, "HH:mm:ss");
                                                        const rowEndTime = moment(felter.end, "HH:mm:ss");

                                                        // Validation 1: Start must be before End (same row)
                                                        if (felter.end && selectedTime.isSameOrAfter(rowEndTime)) {
                                                            alert("Starttidspunkt skal være før sluttidspunkt!");
                                                            return;
                                                        }

                                                        // Validation 2: Prevent overlap with other rows
                                                        const isOverlapping = interval.some((item, i) => {
                                                            if (i === index || !item.start || !item.end) return false;
                                                            const otherStart = moment(item.start, "HH:mm:ss");
                                                            const otherEnd = moment(item.end, "HH:mm:ss");

                                                            return (
                                                                rowEndTime.isValid() &&
                                                                selectedTime.isBefore(otherEnd) &&
                                                                rowEndTime.isAfter(otherStart)
                                                            );
                                                        });

                                                        if (isOverlapping) {
                                                            alert("Denne tid overlapper med en anden række!");
                                                            return;
                                                        }

                                                        setInterval(
                                                            update(interval, {
                                                                [index]: { start: { $set: value } }
                                                            })
                                                        );
                                                    }}
                                                    text="Start"
                                                />
                                            </Grid>
                                            <Grid item sm={4} style={{ width: "100%" }}>
                                                <Clock
                                                    style={{ flex: 1 }}
                                                    value={felter.end}
                                                    // changeValue={value => {
                                                    //     if (felter.start && value < felter.start)
                                                    //         alert("Sluttidspunkt skal være efter starttidspunkt!");
                                                    //     else
                                                    //         setInterval(
                                                    //             update(interval, {
                                                    //                 [index]: { end: { $set: value } }
                                                    //             })
                                                    //         );
                                                    // }}

                                                    // changeValue={value => {
                                                    //     const selectedTime = moment(value, "HH:mm:ss");
                                                    //     const rowStartTime = moment(felter.start, "HH:mm:ss");

                                                    //     // Validation 1: End must be after Start (same row)
                                                    //     if (felter.start && selectedTime.isSameOrBefore(rowStartTime)) {
                                                    //         alert("Sluttidspunkt skal være efter starttidspunkt!");
                                                    //         return;
                                                    //     }

                                                    //     // Validation 2: Prevent overlap with other rows
                                                    //     const isOverlapping = interval.some((item, i) => {
                                                    //         if (i === index || !item.start || !item.end) return false;
                                                    //         const otherStart = moment(item.start, "HH:mm:ss");
                                                    //         const otherEnd = moment(item.end, "HH:mm:ss");
                                                    //         return selectedTime.isBetween(
                                                    //             otherStart,
                                                    //             otherEnd,
                                                    //             null,
                                                    //             "(]"
                                                    //         );
                                                    //     });

                                                    //     if (isOverlapping) {
                                                    //         alert("Denne tid overlapper med en anden række!");
                                                    //         return;
                                                    //     }

                                                    //     // Passes all validations
                                                    //     setInterval(
                                                    //         update(interval, {
                                                    //             [index]: { end: { $set: value } }
                                                    //         })
                                                    //     );
                                                    // }}

                                                    changeValue={value => {
                                                        const selectedTime = moment(value, "HH:mm:ss");
                                                        const rowStartTime = moment(felter.start, "HH:mm:ss");

                                                        if (felter.start && selectedTime.isSameOrBefore(rowStartTime)) {
                                                            alert("Sluttidspunkt skal være efter starttidspunkt!");
                                                            return;
                                                        }

                                                        const isOverlapping = interval.some((item, i) => {
                                                            if (i === index || !item.start || !item.end) return false;
                                                            const otherStart = moment(item.start, "HH:mm:ss");
                                                            const otherEnd = moment(item.end, "HH:mm:ss");

                                                            return (
                                                                rowStartTime.isValid() &&
                                                                selectedTime.isAfter(otherStart) &&
                                                                rowStartTime.isBefore(otherEnd)
                                                            );
                                                        });

                                                        if (isOverlapping) {
                                                            alert("Denne tid overlapper med en anden række!");
                                                            return;
                                                        }

                                                        setInterval(
                                                            update(interval, {
                                                                [index]: { end: { $set: value } }
                                                            })
                                                        );
                                                    }}
                                                    text="Slut"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                sm={4}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}>
                                                <Button
                                                    onClick={() =>
                                                        setInterval(update(interval, { $splice: [[index, 1]] }))
                                                    }
                                                    color="secondary">
                                                    Slet
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                );
                            })}
                            <Button
                                onClick={() => setInterval(update(interval, { $push: [{ start: "", end: "" }] }))}
                                style={{
                                    backgroundColor: "#343434",
                                    color: "#fff"
                                }}
                                variant="contained"
                                startIcon={<AddCircleIcon />}>
                                Tilføj åbningsinterval
                            </Button>
                        </div>

                        <Button
                            style={{ float: "right", color: "#fff" }}
                            color="primary"
                            variant="contained"
                            onClick={handleSave}
                            disabled={loading}>
                            {loading && <CircularProgress size={24} style={{ marginRight: 8 }} />}
                            Gem Indstilling
                        </Button>
                        <Button
                            style={{ float: "right" }}
                            onClick={() => {
                                props.handleClose();
                                setWeekDay("");
                            }}>
                            Luk
                        </Button>
                    </div>
                ) : (
                    <>
                        <div className={classes.prescreen}>Vælg en ugedag du vil sætte åbningstid for</div>
                        <div>
                            <Button
                                style={{ float: "right" }}
                                onClick={() => {
                                    props.handleClose();
                                    setWeekDay("");
                                }}>
                                Luk
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </Dialog>
    );
};
